import { useInView } from '../hooks/useInView';
import { STACK_LAYERS } from '../data';

function LayerCard({ layer, index }) {
  const [ref, inView] = useInView(0.12);
  return (
    <div ref={ref}
         className="bg-surf border border-bord rounded-2xl overflow-hidden mb-3.5 border-l-[4px] transition-all duration-500"
         style={{
           borderLeftColor: layer.color,
           opacity: inView ? 1 : 0,
           transform: inView ? 'none' : 'translateX(-18px)',
           transitionDelay: `${index * 0.09}s`,
         }}>
      <div className="flex items-center gap-2 px-4 py-3 border-b border-bord">
        <div className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: layer.color }} />
        <span className="font-mono text-[10px] font-medium tracking-[1.5px]" style={{ color: layer.color }}>
          {layer.label.toUpperCase()}
        </span>
      </div>
      <div className="flex flex-wrap gap-2.5 p-4">
        {layer.items.map((item, i) => (
          <div key={i}
               className="flex items-start gap-2.5 p-3 rounded-xl bg-surf2 border border-bord flex-1 min-w-[160px]
                          transition-all duration-200 hover:border-opacity-50 cursor-default group"
               style={{ '--hover-color': layer.color }}
               onMouseEnter={e => { e.currentTarget.style.borderColor = layer.color + '55'; e.currentTarget.style.background = layer.color + '08'; }}
               onMouseLeave={e => { e.currentTarget.style.borderColor = ''; e.currentTarget.style.background = ''; }}>
            <span className="text-base flex-shrink-0 mt-0.5">{item.icon}</span>
            <div>
              <div className="font-bold text-xs text-tx mb-0.5">{item.name}</div>
              <div className="text-[11px] text-tx2">{item.desc}</div>
              <div className="font-mono text-[9px] text-tx3 mt-1">{item.sub}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Stack() {
  return (
    <section id="stack" className="relative z-10 py-24 px-5 sm:px-8"
             style={{ background: 'linear-gradient(180deg,#0d1220 0%,#080c14 100%)' }}>
      <div className="max-w-5xl mx-auto">
        <div className="mb-12">
          <span className="section-tag bg-aws/[.13] border border-aws/22 text-aws">{`// TECH STACK`}</span>
          <h2 className="font-display font-extrabold tracking-tight" style={{ fontSize: 'clamp(28px,4vw,46px)' }}>
            Architecture I <span className="text-aws">build with</span>
          </h2>
        </div>
        {STACK_LAYERS.map((layer, i) => <LayerCard key={i} layer={layer} index={i} />)}
      </div>
    </section>
  );
}
